import { render } from "./StockOpLog.vue?vue&type=template&id=1702d93e&scoped=true&ts=true"
import script from "./StockOpLog.vue?vue&type=script&lang=ts"
export * from "./StockOpLog.vue?vue&type=script&lang=ts"

import "./StockOpLog.vue?vue&type=style&index=0&id=1702d93e&scoped=true&lang=less"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1702d93e"]])

export default __exports__